<template>
    <div class="casesHeder">
        <div class="casesHeder_banner_txt">
            <!-- <div class="casesHederVanner_txt">
                <h1>精品案例展示</h1>
                <p>虚拟场景营销，全栈开发团队 <br>无论整体，还是细节，我们都力争完美！</p>
                <div class="casesHeder_Clicknow">
                    免费咨询
                </div>
            </div> -->
        </div>  
        <div class="casesHeder_op"></div>
    </div>
</template>
<script>
export default {
    name:"casesHeder",
}
</script>
<style scoped>
@media screen and (min-width: 1921px) {
  .casesHeder{
    height: 780px!important;
  }
}
.casesHeder{
    width: 100%;
    height: 640px;
    background: #142443;
    position: relative;
}
.casesHeder_op{
    width: 100%;
    height: 100%;
    background: url("http://oss.3dyunchuang.com/home_pic/banner/cases_header_bg.jpg");
    background-size: 100% 100%;
    opacity:1;
    position: absolute;
    left: 0;
    top: 0;
}
.casesHeder_banner_txt{
    width: 1202px;
    height: 100%;
    margin: 0 auto;
}
.casesHederVanner_txt{
    float: left;
    width: 483px;
    height: 380px;
    margin-top: 225px;
}
.casesHederVanner_txt h1{
    font-size: 45px;
    color: #fff;
    letter-spacing:6px;
    margin-bottom: 20px;
}
.casesHederVanner_txt p{
    color: #c5cacf;
    font-size: 16px;
    letter-spacing:2px;
    line-height: 26px;
}
.casesHeder_Clicknow{
    width: 113px;
    height: 40px;
    border: 1px solid #fff;
    text-align: center;
    line-height: 40px;
    color: #fff;
    margin-top: 60px;
    font-size: 14px;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/common/cases/cases-heder.vue